import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import FloatSelectSingle from "../Floating/FloatSelectSingle";
import { typeOptions } from "../../utils/constant";
import { harmonizationCourses } from "../../appRedux/actions/courses";
function FilterHarmonize({ initialFetchComplete }) {
  const dispatch = useDispatch();
  const [type, setType] = useState("category");
  const { queryInfo, courseFilters, setOldQueryInfo } = useSelector(
    (state) => ({
      queryInfo: state.courses.queryInfo,
      courseFilters: state.courses.courseFilters,
      setOldQueryInfo: state.courses.setOldQueryInfo,
    })
  );
  console.log("queryInfo", queryInfo);
  const harmonization = useSelector((state) => state.courses.harmonize);
  const [categoriesList, setCategoriesList] = useState(courseFilters.category);

  const [affiliationList, setAffiliationList] = useState(
    courseFilters.affiliation
  );

  console.log("courseFilters", courseFilters);
  const [courseTypeList, setCourseTypeList] = useState(
    courseFilters.courseType
  );

  const [originalCategoriesList, setOriginalCategoriesList] = useState(
    courseFilters.originalCategory
  );
  const [originalAffiliation, setOriginalAffiliation] = useState(
    courseFilters.originalAffiliation
  );
  const [originalCourseType, setOriginalCourseType] = useState(
    courseFilters.originalCourse_type
  );

  const [value1, setValue1] = useState(null);
  const [value2, setValue2] = useState(null);
  const [modifiedCount, setModifiedCount] = useState(null);

  const optionsMap = {
    category: categoriesList || [],
    affiliation: affiliationList || [],
    courseType: courseTypeList || [], // fallback to [] if undefined
  };

  const originalMap = {
    category: originalCategoriesList || [],
    affiliation: originalAffiliation || [],
    courseType: originalCourseType || [], // fallback to [] if undefined
  };
  const filteredOptions2 = optionsMap[type]?.filter(
    (item) => item._id !== value1
  );

  useEffect(() => {
    setCategoriesList(courseFilters.category);
    setAffiliationList(courseFilters.affiliation);
    setCourseTypeList(courseFilters.courseType);
    setOriginalCategoriesList(courseFilters.originalCategory);
    setOriginalAffiliation(courseFilters.originalAffiliation);
    setOriginalCourseType(courseFilters.originalCourseType);
  }, [courseFilters]);

  const handleSubmit = () => {
    if (!value1 || !value2) {
      alert("Please select both fields.");
      return;
    }

    if (value1 === value2) {
      alert("Both selections must be different.");
      return;
    }
    const payload = {
      type,
      idFrom: value1,
      idTo: value2,
    };

    console.log("Submitting", payload);

    dispatch(harmonizationCourses(payload))
      .then((response) => {
        if (response && !response.error) {
          alert(
            `${
              type.charAt(0).toUpperCase() + type.slice(1)
            } harmonization completed successfully.`
          );
          setModifiedCount(response.results.modifiedCount);

          // Optional: clear fields
          setValue1(null);
          setValue2(null);
        }
      })
      .catch((err) => {
        console.error("Harmonization failed:", err);
        alert("Something went wrong during harmonization.");
      });
    setValue1(null);
    setValue2(null);
  };
  return (
    <div className="row filter-row">
      {/* Type Selector */}
      <div className="col-sm-6 col-md-2 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus">
          <FloatSelectSingle
            label="Choose Type"
            value={type}
            name="types"
            id="inputCustom"
            tag2="code"
            onChange={(value) => {
              setType(value);
              setValue1(null);
              setValue2(null);
            }}
            options={typeOptions}
          />
        </div>
      </div>

      {/* First Select */}
      <div className="col-sm-6 col-md-3 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus">
          <FloatSelectSingle
            label={`Select ${type
              .replace("_", " ")
              .charAt(0)
              .toUpperCase()}${type.slice(1)} ORIGINAL`}
            value={value1}
            name={`${type}_1`}
            id="inputCustom"
            tag2="_id"
            showSearch={true}
            onChange={(val) => setValue1(val)}
            options={originalMap[type]}
          />
        </div>
      </div>

      {/* Second Select - excludes first selection */}
      <div className="col-sm-6 col-md-3 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus">
          <FloatSelectSingle
            label={`Select ${type
              .replace("_", " ")
              .charAt(0)
              .toUpperCase()}${type.slice(1)} NEW`}
            value={value2}
            name={`${type}_2`}
            id="inputCustom"
            tag2="_id"
            showSearch={true}
            onChange={(val) => setValue2(val)}
            options={filteredOptions2}
            disabled={!value1}
          />
        </div>
      </div>
      {modifiedCount !== null && (
        <div className="col-sm-6 col-md-2 pl-1 pr-1 pb-2">
          <div
            style={{
              padding: "12px",
              backgroundColor: "#e6f7ff",
              border: "1px solid #91d5ff",
              borderRadius: "8px",
              color: "#0050b3",
              fontWeight: "500",
            }}
          >
            Modified Courses: {modifiedCount}
          </div>
        </div>
      )}
      {/* Submit Button */}
      <div className="col-sm-6 col-md-2">
        <button
          className="btn btn-success btn-block full-width w-100"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

FilterHarmonize.propTypes = {};

export default FilterHarmonize;
